// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Cef_","paramInput":"JobSimulator_paramInput__flsOX","input":"JobSimulator_input__2EjWA"};